import { ComingSoonBackSoonRequestBody } from './coming-soon-back-soon.models';

import { ApiComingSoonBackSoonRequestBody } from '@api/_api/api-coming-soon-back-soon/api-coming-soon-back-soon.models';

/**
 * Tranformer de datos para el servicio de comingSoonBackSoon
 */

export class ComingSoonBackSoonTransformer {
    public static comingSoonBackSoonBodyToApi(request: ComingSoonBackSoonRequestBody): ApiComingSoonBackSoonRequestBody {
        const apiRequest: ApiComingSoonBackSoonRequestBody = {
            email: request.email,
            sku: request.sku,
            quantity: request.quantity,
            hash: request.hash,
            captchaId: request.captchaId,
            captchaValue: request.captchaValue,
        };

        return apiRequest;
    }
}
